import React from "react";
import InputProfileCell from "./cells/InputProfileCell";
import InputTitleCell from "./cells/InputTitleCell";
import ForwarderCell from "./cells/ForwarderCell";
import ForwarderStatusCell from "./cells/ForwarderStatusCell";
import ForwarderVersionCell from "./cells/ForwarderVersionCell";
import InputStateCell from "./cells/InputStateCell";
import TrafficLastMinuteCell from "./cells/TrafficLastMinuteCell";
import ExpandedSectionToggleWrapper from "./ExpandedSectionToggleWrapper";
const forwarderInputColumnRenderers = ({ inputTypes }) => ({
  attributes: {
    title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(InputTitleCell, { input })),
      width: 0.3
    },
    type: {
      renderCell: (type, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement("span", null, (inputTypes == null ? void 0 : inputTypes[type]) || type)),
      width: 0.3
    },
    input_profile_id: {
      renderCell: (profileId, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(InputProfileCell, { profileId })),
      width: 0.3
    },
    forwarder_title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(ForwarderCell, { forwarderId: input.forwarder_id, forwarderTitle: input.forwarder_title })),
      width: 0.3
    },
    forwarder_status: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(ForwarderStatusCell, { forwarderId: input.forwarder_id })),
      staticWidth: 130
    },
    forwarder_version: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(ForwarderVersionCell, { forwarderId: input.forwarder_id })),
      staticWidth: "matchHeader"
    },
    input_state: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(InputStateCell, { forwarderId: input.forwarder_id, inputId: input.input_id, state: input.input_state, stateMessage: input.state_message })),
      staticWidth: 130
    },
    traffic_last_minute: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(TrafficLastMinuteCell, { forwarderId: input.forwarder_id, inputId: input.input_id })),
      staticWidth: "matchHeader"
    },
    address: {
      renderCell: (_address, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement("span", null, ((_a = input.configuration) == null ? void 0 : _a.bind_address) || "N/A"));
      },
      staticWidth: 125
    },
    port: {
      renderCell: (_port, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement("span", null, ((_a = input.configuration) == null ? void 0 : _a.port) || "N/A"));
      },
      staticWidth: "matchHeader"
    }
  }
});
export default forwarderInputColumnRenderers;
